var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    {
      key: "2",
      staticClass: "text-center",
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "ma-0 pa-0 btnCanvas",
                      staticStyle: {
                        background: "transparent !important",
                        "pointer-events": "all",
                      },
                      attrs: {
                        elevation: "0",
                        rounded: "",
                        "x-small": "",
                        disabled: !_vm.canAddToCart,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.clickFavButton()
                        },
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text", attrs: { large: "" } },
                    [_vm._v(_vm._s(_vm.FavIcon))]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(
        " " +
          _vm._s(_vm.$t("message.Salva_momentaneamente_la_configurazione")) +
          " "
      ),
      _c("br"),
      !_vm.configurationComplete
        ? _c("span", { staticClass: "text-center" }, [
            _vm._v(
              "(" +
                _vm._s(
                  _vm.$t("message.completa_una_configurazione_per_salvarla")
                ) +
                ")"
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }